import config, { setConfig } from "@/config";

async function loadConfig(url: string): Promise<any> {
  let error: Error;

  for (let i = 0; i < 3; i++) {
    try {
      return await (await fetch(url, { cache: "no-store" })).json();
    } catch (e) {
      if (process.env.NODE_ENV !== "production") return {};
      error = new Error("Error loading config: " + e.message);
      await new Promise(r => setTimeout(r, 1000));
    }
  }
  return Promise.reject(error!);
}

export default function() {
  return Promise.all([
    loadConfig(`${config.backendUrl}/system-settings/frontend-config`),
  ]).then(configs => configs.forEach(c => setConfig(c)));
}
